/**
 * @file uploaderMixin
 * @author fuqiang15
 */

import Uploader from '@/common/components/Uploader';

export default {
    data() {
        return {
            btnStatus: {
                disabled: false,
                loading: false
            }
        };
    },
    components: {
        Uploader
    },
    methods: {
        switchBtnStatus(status) {
            if (status === 'failure') {
                this.btnStatus = {
                    disabled: true,
                    loading: false
                };
            }
            else if (status === 'uploading') {
                this.btnStatus = {
                    disabled: false,
                    loading: true
                };
            }
            else {
                this.btnStatus = {
                    disabled: false,
                    loading: false
                };
            }
        }
    }
};
